import deepmerge from 'deepmerge'
import { getColourScheme, ColourScheme } from 'APP/Helpers/AppearanceUtils'
import { isWeb } from 'APP/Helpers/checkPlatform'

/* eslint-disable import/no-unresolved */
// This issue happens because the images don't exist currently and are copied when this environment is used.
import BrowseIcon from 'APP/Images/v2/Navigation/browse-icon.svg'
import BrowseIconFilled from 'APP/Images/v2/Navigation/browse-icon-filled.svg'
import ChatIcon from 'APP/Images/v2/Navigation/chat-icon.svg'
import HomeIcon from 'APP/Images/v2/Navigation/home-icon.svg'
import HomeIconFilled from 'APP/Images/v2/Navigation/home-icon-filled.svg'
import MoveIcon from 'APP/Images/v2/Navigation/move-icon.svg'
import MoveIconFilled from 'APP/Images/v2/Navigation/move-icon-filled.svg'
import ServicesIcon from 'APP/Images/v2/Navigation/services-icon.svg'
import ServicesIconFilled from 'APP/Images/v2/Navigation/services-icon-filled.svg'

import DietNutritionIcon from 'APP/Images/v2/ServiceGroups/dietNutrition.svg'
import ExternalHealthResourcesIcon from 'APP/Images/v2/ServiceGroups/externalHealthResources.svg'
import FamilyRelationshipsIcon from 'APP/Images/v2/ServiceGroups/familyRelationships.svg'
import FinancialIcon from 'APP/Images/v2/ServiceGroups/financial.svg'
import LegalIcon from 'APP/Images/v2/ServiceGroups/legal.svg'
import MedicalSecondOpinionIcon from 'APP/Images/v2/ServiceGroups/medicalSecondOpinion.svg'
import MentalHealthIcon from 'APP/Images/v2/ServiceGroups/mentalHealth.svg'
import PhysicalHealthIcon from 'APP/Images/v2/ServiceGroups/physicalHealth.svg'
import PrescriptionChatIcon from 'APP/Images/v2/ServiceGroups/prescriptionChat.svg'
import PrescriptionManageIcon from 'APP/Images/v2/ServiceGroups/prescriptionManage.svg'
import PrescriptionRefillIcon from 'APP/Images/v2/ServiceGroups/prescriptionRefill.svg'
import TechnicalSupportIcon from 'APP/Images/v2/ServiceGroups/technicalSupport.svg'
import WorkCareerIcon from 'APP/Images/v2/ServiceGroups/workCareer.svg'
import TrackIcon from 'APP/Images/v2/ServiceGroups/track.svg'
import PharmacySupportIcon from 'APP/Images/v2/ServiceGroups/pharmacySupport.svg'
import PrescriptionAddIcon from 'APP/Images/v2/ServiceGroups/prescriptionAdd.svg'
import OnlinePharmacyIcon from 'APP/Images/v2/ServiceGroups/onlinePharmacy.svg'
import AsthmaIcon from 'APP/Images/v2/ServiceGroups/asthma.svg'
import DiabetesIcon from 'APP/Images/v2/ServiceGroups/diabetes.svg'
import QuittingSmokingIcon from 'APP/Images/v2/ServiceGroups/quittingSmoking.svg'
import HealthConcernsIcon from 'APP/Images/v2/ServiceGroups/healthConcerns.svg'
import QRCodeAppStore from 'APP/Images/v2/qr_code_app_store.svg'
/* eslint-enable import/no-unresolved */

const logoMobile = require('APP/Images/v2/ic_logo.png')
const logoWeb = require('APP/Images/v2/ic_logo_web.png')

const imagesBase = {
  logoBlue: isWeb() ? logoWeb : logoMobile,
  logoErrorIcon: require('APP/Images/v2/ic_logo.png'),
  logoLockup: require('APP/Images/v2/logo_lockup.png'),
  logoConsent: require('APP/Images/v2/logo_consent.png'),

  welcomeSlide0: require('APP/Images/v2/welcome_slide_0.png'),
  welcomeSlide1: require('APP/Images/v2/welcome_slide_1.png'),
  welcomeSlide2: require('APP/Images/v2/welcome_slide_2.png'),
  welcomeSlide3: require('APP/Images/v2/welcome_slide_3.png'),

  browseIcon: BrowseIcon,
  browseIconFilled: BrowseIconFilled,
  chatIcon: ChatIcon,
  todayIcon: HomeIcon,
  todayIconFilled: HomeIconFilled,
  moveIcon: MoveIcon,
  moveIconFilled: MoveIconFilled,
  servicesIcon: ServicesIcon,
  servicesIconFilled: ServicesIconFilled,

  qrCodeAppStore: QRCodeAppStore,

  unsupportedVersionIllustration: require('APP/Images/v2/il_download.png'),

  serviceCategories: {
    healthConcerns: require('APP/Images/v2/WellnessCategories/physicalHealth.png'),
    mentalHealth: require('APP/Images/v2/WellnessCategories/mentalHealth.png'),
    legal: require('APP/Images/v2/WellnessCategories/legal.png'),
    financial: require('APP/Images/v2/WellnessCategories/financial.png'),
    familyRelationships: require('APP/Images/v2/WellnessCategories/familyRelationships.png'),
    workCareer: require('APP/Images/v2/WellnessCategories/workCareer.png'),
    technicalSupport: require('APP/Images/v2/WellnessCategories/technicalSupport.png'),
  },

  notificationsExample: require('APP/Images/v2/il_notifications_example.png'),

  serviceGroups: {
    dietNutrition: DietNutritionIcon,
    externalHealthResources: ExternalHealthResourcesIcon,
    familyRelationships: FamilyRelationshipsIcon,
    financial: FinancialIcon,
    legal: LegalIcon,
    mentalHealth: MentalHealthIcon,
    medicalSecondOpinion: MedicalSecondOpinionIcon,
    physicalHealth: PhysicalHealthIcon,
    prescriptionChat: PrescriptionChatIcon,
    prescriptionManage: PrescriptionManageIcon,
    prescriptionRefill: PrescriptionRefillIcon,
    technicalSupport: TechnicalSupportIcon,
    workCareer: WorkCareerIcon,
    track: TrackIcon,
    pharmacySupport: PharmacySupportIcon,
    prescriptionAdd: PrescriptionAddIcon,
    onlinePharmacy: OnlinePharmacyIcon,
    asthma: AsthmaIcon,
    diabetes: DiabetesIcon,
    quittingSmoking: QuittingSmokingIcon,
    healthConcerns: HealthConcernsIcon,
  },
}

const logoDarkMobile = require('APP/Images/v2/ic_logo.png')
const logoDarkWeb = require('APP/Images/v2/ic_logo_web.png')

const imagesDark = {
  logoBlue: isWeb() ? logoDarkWeb : logoDarkMobile,
  logoErrorIcon: require('APP/Images/v2/ic_logo.png'),
  logoLockup: require('APP/Images/v2/logo_lockup_dark.png'),

  unsupportedVersionIllustration: require('APP/Images/v2/il_download_dark.png'),

  serviceCategories: {
    healthConcerns: require('APP/Images/v2/WellnessCategories/physicalHealthDark.png'),
    mentalHealth: require('APP/Images/v2/WellnessCategories/mentalHealthDark.png'),
    legal: require('APP/Images/v2/WellnessCategories/legalDark.png'),
    financial: require('APP/Images/v2/WellnessCategories/financialDark.png'),
    familyRelationships: require('APP/Images/v2/WellnessCategories/familyRelationshipsDark.png'),
    workCareer: require('APP/Images/v2/WellnessCategories/workCareerDark.png'),
    technicalSupport: require('APP/Images/v2/WellnessCategories/technicalSupportDark.png'),
  },
}

export const Images =
  getColourScheme() === ColourScheme.DARK ? deepmerge(imagesBase, imagesDark) : imagesBase

export default Images
